// extracted by mini-css-extract-plugin
module.exports = {"battery-backup-Global":"Global_battery-backup-Global__yRYMJ"};